import { SaldoAdiantamento } from '../_models';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AlertService } from '../_services/alert.service';
import {environment} from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class SaldoAdiantamentoService {

    getSaldosAdiantamentos(idSapFornecedor: string): Observable<any> {
        return this.http.get<SaldoAdiantamento[]>(`${environment.apiUrl}/api/SaldoAdiantamentos?idSapFornecedor=` + idSapFornecedor);
    }

    constructor(private http: HttpClient,
        private alertService: AlertService) { }
}
